import DataHelper from './data-helper.js';

export default class OrderableHelper {
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el;
    this.data = parent.data;
    this.pricing = parent.pricing;

    this.grades = [...this.el.querySelectorAll('.configurator--grade')];
    this.engines = [...this.el.querySelectorAll('.configurator--engine')];
    this.colours = [...this.el.querySelectorAll('.configurator--colour')];
    this.trims = [...this.el.querySelectorAll('.configurator--trim')];
    this.wheels = [...this.el.querySelectorAll('.configurator--wheel')];
    this.interiorAccessories = [...this.el.querySelectorAll('.configurator--featured-interior-item')];
    this.exteriorAccessories = [...this.el.querySelectorAll('.configurator--featured-exterior-item')];
  }

  init() {
    this.removeData();
    this.removeElements();
  }

  removeData() {
    this.orderableCars = [];
    this.orderableColourTrims = [];

    this.data.cars.forEach((car) => {
      const mtoPricing = this.pricing.getCarMTOPricing(car.mto);

      const mtoccOrderable = mtoPricing?.['c_mtocc']?.reduce((map, mtocc) => {
        const key = `${mtocc['c_extColourCode']}|${mtocc['c_intColourCode']}`;
        const orderable = mtocc['c_orderability'] !== false;
        map[key] = orderable;        
        return map;
      }, {}) ?? {};

      car.colourTrims = car.colourTrims.filter((colourTrim) => {
        const colour = colourTrim['colourMTOCE'];
        const trim = colourTrim['trimMTOCE'];
        const key = `${colour}|${trim}`;
        const orderable = mtoccOrderable[key];
        if(orderable) {
          this.orderableColourTrims.push({ colour: colourTrim.colour, trim: colourTrim.trim });
        } else {
          console.log('Orderability - Removing - Unorderable colour trim combination - Colour: ', colour, ' - Trim: ', trim);
        }
        return orderable;
      });

      const defaultColourTrimKey = `${car.defaultColourTrim['colourMTOCE']}|${car.defaultColourTrim['trimMTOCE']}`
      const defaultColourTrimOrderable = mtoccOrderable[defaultColourTrimKey];

      const colourPrice = (ct) => Number(mtoPricing['c_colours'].find((colour) => colour.ean === ct.colourMTOCE)?.grossPrice ?? NaN);
      const trimPrice = (ct) => Number(mtoPricing['c_trims'].find((colour) => colour.ean === ct.trimMTOCE)?.grossPrice ?? NaN);
      const colourTrimPrice = (ct) => colourPrice(ct) + trimPrice(ct);

      if(!defaultColourTrimOrderable) {
        car.defaultColourTrim = car.colourTrims.reduce((acc, curr) => !acc || colourTrimPrice(curr) < colourTrimPrice(acc) ? curr : acc, null);
      }

      DataHelper.processCar(car);
    });

    this.data.cars = this.data.cars.filter((car) => {
      const orderable = car.colourTrims.length > 0;
      if(orderable) {
        this.orderableCars.push({ grade: car.gradeCode, engine: car.engineTDCode });
      } else {
        console.log('Orderability - Removing - Car has no orderable colour trim combinations - ', car.code);
      }
      return orderable;
    });

    if(this.data.cars.length === 0) {
      console.error('Orderability - Error - No orderable cars remaining');
    }
  }

  removeElements() {
    this.grades.forEach((el) => {
      const id = el.dataset.id;
      const orderable = this.orderableCars.some((car) => car.grade === id);
      if(!orderable) {
        el.remove();
      }
    });

    this.engines.forEach((el) => {
      const id = el.dataset.id;
      const orderable = this.orderableCars.some((car) => car.engine === id);
      if(!orderable) {
        el.remove();
      }
    });

    this.colours.forEach((el) => {
      const id = el.dataset.id;
      const orderable = this.orderableColourTrims.some((colourTrim) => colourTrim.colour === id);
      if(!orderable) {
        el.remove();
      }
    });

    this.trims.forEach((el) => {
      const id = el.dataset.id;
      const orderable = this.orderableColourTrims.some((colourTrim) => colourTrim.trim === id);
      if(!orderable) {
        el.remove();
      }
    });

    // Generic function for removing unorderable elements
    const removeUnorderable = (elements, getCarIds) => {
      elements.forEach((el) => {
        const id = el.dataset.id;
        // Find cars that have this item (wheel/accessory)
        const carsWithItem = this.data.cars.filter((car) => getCarIds(car).includes(id));
        // Check if any of those cars are orderable
        const orderable = carsWithItem.some((car) =>
          this.orderableCars.some((orderableCar) =>
            orderableCar.grade === car.gradeCode && orderableCar.engine === car.engineTDCode
          )
        );
        if (!orderable) {
          el.remove();
        }
      });
    };

    // Use the generic function for wheels, interior, and exterior accessories
    removeUnorderable(this.wheels, (car) => car.wheels || []);
    removeUnorderable(this.interiorAccessories, (car) => car.accessories || []);
    removeUnorderable(this.exteriorAccessories, (car) => car.accessories || []);
  }
}